import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  makeStyles,
  Drawer,
  CardHeader,
  IconButton,
  CardContent,
  Button,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme) => ({
  drawer: {
    marginTop: '6.8rem',
    paddingBottom: '6.8rem',
    width: '19rem',
  },
  resetButton: {
    margin: 0,
    width: '100%',
  },
  resetButtonContainer: {
    width: '100%',
    padding: theme.spacing(2),
  },
}));

interface FilterDrawerProps {
  open?: boolean;
  onClose?: () => void;
  onResetFilters?: () => void;
  children: React.ReactNode;
}

const FilterDrawer: React.FC<FilterDrawerProps> = ({
  open,
  onClose,
  onResetFilters,
  children,
}) => {
  const classes = useStyles();
  const { t } = useTranslation(['translations']);
  return (
    <Drawer
      variant="persistent"
      anchor="right"
      open={open}
      classes={{ paper: classes.drawer }}
    >
      <CardHeader
        title={t('filter_drawer.title')}
        action={
          <IconButton onClick={onClose} color="secondary">
            <CloseIcon />
          </IconButton>
        }
      />
      <CardContent>{children}</CardContent>
      <div className={classes.resetButtonContainer}>
        <Button
          classes={{ root: classes.resetButton }}
          variant="contained"
          color="primary"
          onClick={onResetFilters}
          // className={classes.resetButton}
        >
          {t('filter_drawer.reset_filters')}
        </Button>
      </div>
    </Drawer>
  );
};

export default FilterDrawer;
